import React from 'react';

class Boundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false, error: null, socket: this.props.socket };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
  
    componentDidCatch(error, errorInfo) {
      this.setState({ error });
  
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
            
          return (
                  <div className={"small-error"}>
                      Error has occured
                  </div>
                  )
      }
  
      return this.props.children; 
      
    }
  }

  export default Boundary;


// WEBPACK FOOTER //
// ./src/components/Boundary.js